export default __webpack_public_path__ + "static/media/IMG4133.b1482096.jpg";